import Vue from 'vue';
import Vuex from 'vuex';
import { getHomeList,getBrandData,postContactUs } from '@/api/common'
Vue.use(Vuex);

const state = {
    homeList: [],
    showMenu: true,
    brandData: {}
}
const mutations = {
    setHomeList(state,homeList){
        state.homeList = homeList
    },
    setShowMenu(state,showMenu){
        state.showMenu = showMenu
    },
    setBrandData(state,brandData){
        state.brandData = brandData
    }
}
const actions = {
    HOMELIST({ commit }) {
        return new Promise((resolve, reject) => {
            getHomeList().then(response => {
                if (response.code) {
                    commit('setHomeList', response.data.items);
                    resolve(response)
                } else {
                    reject(response.msg)
                }
            }).catch(error => {
                reject(error)
            })
        })
    },
    BRANDDATA({commit}){
        return new Promise((resolve, reject) => {
            getBrandData().then(response => {
                if (response.code) {
                    commit('setBrandData', response.data);
                    resolve(response)
                } else {
                    reject(response.msg)
                }
            }).catch(error => {
                reject(error)
            })
        })
    },
    CONTACTUS({},params){
        return new Promise((resolve, reject) => {
            postContactUs(params).then(response => {
                if (response.code) {
                    resolve(response)
                } else {
                    reject(response.msg)
                }
            }).catch(error => {
                reject(error)
            })
        })
    }
}
const getters = {
    GET_HOMELIST: state => {
        return state.homeList || []
    },
    GET_BRANDDATA: state => {
        return state.brandData || {}
    }
}
export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}